module.exports = __webpack_public_path__ + "media/images/mother-day/motherday-template-md-7de7572328e29f44c8c7d8931156a58e.png";